module.exports = __webpack_public_path__ + "img/huajiadian1.7b7048d3.png";